import {IAccount, IAccountOperation} from "../../models/accounting/accounting.interface";

export interface IAccountingState {
  data:Array<IAccount>;
  isLoaded: boolean;

}
export const initialAccountingState:IAccountingState = {
  data: [],
  isLoaded: false
};

export interface IAccountOperationsState {
  data: Array<IAccountOperation>;
  isLoaded: boolean;
}
export const initialAccountOperationsState: IAccountOperationsState = {
  data: [],
  isLoaded: false
};





